import React, { Component } from 'react';

import classes from './LanguageSwitch.module.css';
import Spinner from '../UI/Spinner/Spinner';
import { getTwoLetterCountryCode } from '../../assets/helpers/utils';
import config from '../../constants/config';

export default class LanguageSwitch extends Component {
  _renderSelected = (selectedCode) => {
    return (
      <div
        key="selected"
        className={classes.SelectedItemWrapper}
        onClick={this.props.toggleLanguageList}
      >
        <div className={classes.SelectedText}>{selectedCode.toUpperCase()}</div>
        <svg className={classes.CaretDownSvg}>
          <use xlinkHref='/sprites.svg#icon-caret-down' />
        </svg>
      </div>
    );
  }
  _renderList = (languages) => {
    if (this.props.showList !== true) {
      return null;
    }
    languages = languages.map((code) => getTwoLetterCountryCode(code, null));
    languages = languages.filter(code => config.SUPPORTED_LANGUAGES.includes(code));
    languages = languages.sort();

    return (
      <div key="list" className={classes.ListWrapper}>
        {languages.map((code, i) => {
          return (
            <div
              key={i}
              className={classes.ListItemWrapper}
              onClick={this.props.changeLanguage.bind(this, code)}
            >
              <div className={classes.ListItemText}>{code.toUpperCase()}</div>
            </div>
          );
        })}
      </div>
    );
  }

  render () {
    let content;
    if (this.props.getConfig.status === 'success' && this.props.getConfig.response.supported_languages.length > 1) {
      content = [
        this._renderSelected(this.props.selected),
        this._renderList(this.props.getConfig.response.supported_languages)
      ];
    } if (this.props.getConfig.status === 'success' && this.props.getConfig.response.supported_languages.length < 2) {
      return null;
    } else if (this.props.getConfig.status !== 'success') {
      content = <div className={classes.SpinnerWrapper}><Spinner size='Tiny' /></div>;
    }

    return (
      <div className={classes.LanguageSwitch}>
        {content}
      </div>
    );
  }
}
